import React, { useState } from 'react';
import Alert from '../../modal/Alert';
import Paging from "../../../layouts/page/Paging";
import PostCard from "./PostCard";
import Modal from 'react-modal';
import GoodsModal from '../../../../domain/goods/components/GoodsModal';
import { setPostCardLike } from '../../../../api/index';

interface Postcard {
    postCardId: number;
    postCardPhoto: string;
    [key: string]: any;
}

interface PostCardListProps {
    postCards: Postcard[] | undefined;
    totalPages: number;
    currentPage: number;
    onPageChange: (page: number) => void;
    emptyMessage?: string;
}

const PostCardList: React.FC<PostCardListProps> = ({
    postCards,
    totalPages,
    currentPage,
    onPageChange,
    emptyMessage,
}) => {
    const [selectedPost, setSelectedPost] = useState<any | null>(null);
    const [localPostCards, setLocalPostCards] = useState<Postcard[]>([]);
    const [showDeactivatedAlert, setShowDeactivatedAlert] = useState(false);

    React.useEffect(() => {
        setLocalPostCards(postCards ?? []);
    }, [postCards]);

    const openModal = (post: Postcard) => {
        setSelectedPost(post);
    };

    const closeModal = () => {
        setSelectedPost(null);
    };

    const handleToggleLike = async (postId: string) => {
        const currentStatus = localStorage.getItem("authorStatus");
        if (currentStatus && currentStatus.toLowerCase() === "hold") {
            setShowDeactivatedAlert(true);
            return;
        }
        try {
            await setPostCardLike(postId);
            setLocalPostCards(prev => prev.map(p =>
                String(p.postCardId) === String(postId)
                    ? { ...p, like: !p.like, likeCount: (p.likeCount ?? 0) + (p.like ? -1 : 1) }
                    : p
            ));
            if (selectedPost && String(selectedPost.postCardId) === String(postId)) {
                setSelectedPost((prev: any) => prev
                    ? { ...prev, like: !prev.like, likeCount: (prev.likeCount ?? 0) + (prev.like ? -1 : 1) }
                    : prev
                );
            }
        } catch (e) {
            console.error('좋아요 토글 실패:', e);
        }
    };

    if (!localPostCards || localPostCards.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-16 gap-3 w-full">
                <p className="text-[#888] text-[15px] md:text-[13px]">{emptyMessage || "보관한 엽서가 없습니다."}</p>
            </div>
        );
    }

    return (
        <div>
            <div className="flex flex-wrap gap-3">
                {localPostCards.map((post) => (
                    <PostCard
                        key={post.postCardId}
                        postCard={{ postCardId: post.postCardId, postCardPhoto: post.postCardPhoto }}
                        onClick={() => openModal(post)}
                    />
                ))}
            </div>

            <div className="mt-10">
                <Paging
                    totalPages={totalPages}
                    currentPage={currentPage}
                    type="book"
                    onPageChange={onPageChange}
                />
            </div>

            <Modal
                isOpen={!!selectedPost}
                onRequestClose={closeModal}
                className="penpal-alert-goods"
                overlayClassName="overlay"
                ariaHideApp={false}
            >
                {selectedPost && (
                    <GoodsModal
                        imageSrc={selectedPost.postCardPhoto}
                        postData={selectedPost}
                        closeModal={closeModal}
                        onToggleLike={handleToggleLike}
                    />
                )}
            </Modal>
            {showDeactivatedAlert && (
                <Alert
                    title="알림"
                    message="현재 계정 이용이 제한된 상태입니다.\n운영 정책 위반으로 인해\n좋아요 기능이 제한되었습니다.\n기존 게시글은 수정 후 안내 메일에 따라 재검토 요청이 가능합니다."
                    onClose={() => setShowDeactivatedAlert(false)}
                />
            )}
        </div>
    );
};

export default PostCardList;
